import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { AuthflowResponse, UserResponse } from '@frx/frx-services';
import { useAuthFlow } from '@frx/frx-react-context';
import { setEvent } from '../utils';

export interface AppContextProps {
  data: {
    token?: AuthflowResponse['token'];
    user?: UserResponse;
  };
}

export const AppContext = createContext<AppContextProps>({} as AppContextProps);
export const AppProvider = ({ children }: { children: ReactNode }) => {
  const authData = useAuthFlow();
  const user = authData.data?.user;
  const token = authData?.data?.token;

  useEffect(() => {
    setEvent({
      user: {
        userId: String(user?.cons_id ?? 'anonymous'),
        userName: String(user?.user_name ?? 'anonymous'),
        userType: 'p2p',
      },
    });
  }, [user]);

  const value = useMemo(
    () => ({
      data: {
        token,
        user,
      },
    }),
    [token, user]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppProvider = () => {
  const context = useContext(AppContext);
  if (!context)
    throw new Error('Must be a children to AppProvider to use context');
  return context;
};
